import { useEffect } from 'react';

export const useShowCookiePolicy = () => {
    useEffect(() => {
        const showCookiePolicy = setTimeout(() => {
            // at the moment there is a bug with the LiveRamp cookie banner api
            // where we cannot show the consentManager, unless
            // - cookie policy has been accepted
            // - cookie banner is hidden
            window.__tcfapi?.('checkConsent', 2, (exists: boolean) => {
                // - cookie policy has been accepted
                if (exists) {
                    window.__tcfapi('showConsentManager', 2);
                    return;
                }

                // - hide cookie banner
                window.__tcfapi('toggleConsentTool', 2, () => {
                    window.__tcfapi('showConsentManager', 2);
                });
            });
        }, 1000);

        return () => {
            clearTimeout(showCookiePolicy);
        };
    }, []);
};
